import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'
import axios from 'axios'
// API URLs
import { config } from '../../config'
// import * as getters  from './getters';
// import * as actions  from './actions';
// import * as mutations  from './mutations';

const base_url = config.base_url
const api_token = config.api_token

axios.interceptors.request.use((cfg) => {
  if (
    store.state.token &&
    cfg.url &&
    String(cfg.url).startsWith(base_url) &&
    !cfg.headers.get('Authorization')
  ) {
    cfg.headers.set('Authorization', 'Bearer:' + store.state.token)
  }
  return cfg
})

// Persist state — UI prefs only; token stays in gdq_token, nothing sensitive in gdqassoc
const vuexPersist = new VuexPersistence({
  key: 'gdqassoc',
  storage: window.localStorage,
  modules: ['mypage_folders_open', 'mypage_reports_open'],
  restoreState: (key, storage) => {
    const saved = JSON.parse(storage.getItem(key) || '{}')
    return {
      mypage_folders_open: !!saved.mypage_folders_open,
      mypage_reports_open: saved.mypage_reports_open !== false
    }
  }
})
// ------------------------------
// The store for our application
// ------------------------------
export const store = createStore({
  //= =====
  // STATE
  //= =====
  state: {
    // Blur all e-mail adresses and names
    anon: false,
    // Running as admin
    asadmin: localStorage.getItem('gdq_asadmin') === '1' ? 1 : 0,
    // -----------------
    // User and Profile
    // -----------------
    status: '',
    token: localStorage.getItem('gdq_token') || '',
    breadcrumbs: [],
    user_id: gdq_getuserid(localStorage.getItem('gdq_token') || ''),
    user: {
      first_name: '',
      family_name: '',
      email: ''
    },
    surveys_total: 0,
    surveys_retrieved: 0,
    profile: {
      company_name: '',
      address_1: '',
      address_2: '',
      zip_code: '',
      city: '',
      country_id: null,
      last_updated: null,
      gdq_short: 0,
      osc: 0,
      aggregated_reports: 0,
      aggregated_full: 0,
      anonymize_survey_on_close: 0,
      spotify: 0,
      consultant_group: 0,
      consultantgroup_id: 0,
      subscription_token: ''
    },
    user_usergroups: [],
    // Misc remembering
    mypage_folders_open: false,
    mypage_reports_open: true,
    // -----------------------------
    // My GDQ Page Reload Indicator
    // -----------------------------
    mygqpage_reload: 0,
    surveymembers_reload: 0,
    // ---------
    // Tutorial
    // ---------
    currenttutorial_id: 0,
    // ---------
    // Material
    // ---------
    currentmaterialid: 0,
    // ------
    // Group
    // ------
    group_loadstatus: 0,
    currentgroup_id: 0,
    currentgroup: {
      id: 0,
      group_name: '',
      group_language_id: 0,
      group_normvalues_id: 0,
      group_folder_id: 0,
      group_reply_to: ''
    },
    groupmembers_loadstatus: 0,
    currentgroupmembers: [],
    groupsurveys_loadstatus: 0,
    currentgroupsurveys: [],
    // -------
    // Survey
    // -------
    currentsurvey_id: 0,
    currentsurvey: {
      id: 0,
      user_id: 0,
      group_id: 0,
      survey_name: '',
      survey_start_date: '',
      survey_start_time: '',
      survey_end_date: '',
      survey_reminder_date: '',
      survey_reminder_time: '',
      survey_type_id: 1,
      survey_status_id: 0,
      survey_normvalues_id: 0,
      survey_language_id: 0,
      survey_invoice_reference: '',
      survey_invitation_subject: '',
      survey_invitation_text: '',
      survey_invitation_consultant_text: '',
      survey_invitation_cc: '',
      survey_stage_id: 0,
      membercount: 0,
      completecount: 0,
      ancient_import: 0,
      spotify: 0
    },
    busysurvey_id: 0,
    surveymailstatus: 0,
    selectedsurveys: [],
    currentsurveymembers: [],
    selectedsurveymembers: [],
    addingsurveymember: false,
    groups: [],
    surveys: [],
    surveycount_1: 0,
    surveycount_2: 0,
    surveycount_3: 0,
    surveycount_4: 0,
    surveycount_9: 0,
    surveycount_deleted: 0,
    foldertree: { data: [], total: 0 },
    folders: [],
    surveytypes: [],
    countries: [],
    consultantstatuses: [],
    languages: [],
    normvalues_countries: [],
    groupmembers_uploaderrors: [],
    currentaggregatedreport_id: 0,
    // Nets payment
    current_netspayment_id: '',
    //= ====================
    // Public Questionnaire
    //= ====================
    questionnaire_admin: false,
    questionnaire_admin_code: '',
    questionnaire_admin_done: false,
    questionnaire_survey_id: 0,
    questionnaire_survey: {
      id: 0,
      user_id: 0,
      group_id: 0,
      survey_name: '',
      survey_start_date: '',
      survey_start_time: '',
      survey_end_date: '',
      survey_type_id: 1,
      survey_status_id: 0,
      survey_normvalues_id: 0,
      survey_language_id: 0,
      survey_invoice_reference: '',
      survey_invitation_subject: '',
      survey_invitation_text: '',
      survey_invitation_consultant_text: '',
      survey_invitation_cc: ''
    },
    questionnaire_consultant: {
      id: 0,
      family_name: '',
      first_name: ''
    },
    questionnaire_questions: [],
    questionnaire_startquestions: [],
    questionnaire_endquestions: [],
    currentquestionnairetoken: '',
    currentquestionnairemember_id: 0,
    currentquestionnairemember: {
      id: 0,
      survey_id: 0,
      groupmember_id: 0,
      groupsurveymember_survey_code: '',
      groupsurveymember_token: '',
      groupsurveymember_status_id: 0,
      included_in_survey: 0,
      groupsurveymember_consent_personal: 0,
      groupsurveymember_start_date: '',
      groupsurveymember_end_date: '',
      groupsurveymember_send_date: '',
      groupsurveymember_remind_date: '',
      groupsurveymember_consent_research: 0
    },
    currentquestionnairegdqanswers: [],
    activitylogtypes: [
      { value: 'All', text: 'All' },
      { value: 'Invitation', text: 'Invitations' },
      { value: 'E-mail', text: 'General E-mail' }
    ],
    currentelearningcourse_id: 0,
    currentelearningstep_id: 0,
    learninghub: {
      my: [],
      course: null,
      enrolment: null,
      progress_loaded: false,
      steps_done: [],
      substeps_done: [],
      loading: false,
      error: null
    }
  },
  //= =========
  // MUTATIONS
  //= =========
  mutations: {
    toggleanon (state) {
      state.anon = !state.anon
    },
    set_current_netspayment_id (state, current_netspayment_id) {
      state.current_netspayment_id = current_netspayment_id
    },
    setfoldersopen (state, visible) {
      state.mypage_folders_open = visible
    },
    setagreportsopen (state, visible) {
      state.mypage_reports_open = visible
    },
    setcurrentaggregatedreport_id (state, payload) {
      state.currentaggregatedreport_id = payload.report_id
    },
    setadmin (state, payload) {
      state.asadmin = payload.asadmin
    },
    // -------------
    // Login/logout
    // -------------
    auth_request (state) {
      state.status = 'loading'
    },
    auth_success (state, payload) {
      state.status = 'success'
      state.token = payload.token
      state.user_id = payload.user_id
    },
    auth_error (state) {
      state.status = 'error'
    },
    logout (state) {
      state.status = ''
      state.token = ''
      state.user_id = 0
      state.user = []
      state.profile = []
      state.currentgroup_id = 0
      state.currentsurvey_id = 0
      state.surveys = []
      state.groupsurveys = []
      state.asadmin = 0
      localStorage.removeItem('gdq_asadmin')
    },
    // --------------------------
    // Profile and user handling
    // --------------------------
    profile_set (state, profile) {
      state.profile = profile
    },
    user_set (state, user) {
      state.user = user
    },
    user_usergroups_set (state, usergroups) {
      state.user_usergroups = usergroups
    },
    tutorial_setcurrent (state, tutorial_id) {
      state.currenttutorial_id = tutorial_id
    },
    // ----------
    // Materials
    // ----------
    material_setcurrent (state, material_id) {
      state.currentmaterial_id = material_id
    },
    // -------------------
    // My GDQ Page Reload
    // -------------------
    mygdqpage_setreload (state) {
      state.mygdqpage_reload = 1 - state.mygdqpage_reload
    },
    // ----------------------
    // Survey Members Reload
    // ----------------------
    surveymembers_setreload (state) {
      state.surveymembers_reload = 1 - state.surveymembers_reload
    },
    // ---------------
    // Group handling
    // ---------------
    group_setloadstatus (state, loadstatus) {
      // 0 = idle
      // 1 = loading
      // 2 = error
      state.group_loadstatus = loadstatus
    },
    group_setcurrent (state, group_id) {
      state.currentgroup_id = group_id
    },
    group_set (state, group) {
      state.currentgroup_id = group.id
      state.currentgroup = group
    },
    group_clearcurrent (state) {
      state.currentgroup_id = 0
      state.currentgroup = {
        id: 0,
        group_name: '',
        group_language_id: 0,
        group_normvalues_id: 0,
        group_folder_id: 0,
        group_reply_to: ''
      }
      state.currentgroupmembers = []
    },
    groups_set (state, groups_result) {
      state.groups = groups_result.result
    },
    groupmembers_setcurrent (state, groupmembers_result) {
      state.currentgroupmembers = groupmembers_result.result
    },
    // -----------------
    // Surveys handling
    // -----------------
    addingsurveymember_set (state, addingsurveymember) {
      state.addingsurveymember = addingsurveymember
    },
    survey_setcurrent (state, survey_id) {
      state.currentsurvey_id = survey_id
      state.addingsurveymember = false
    },
    survey_set (state, survey) {
      state.currentsurvey_id = survey.id
      state.currentsurvey = survey
    },
    surveys_setselected (state, surveys) {
      state.selectedsurveys = surveys
    },
    surveymembers_setselected (state, surveymembers) {
      state.selectedsurveymembers = surveymembers
    },
    surveymembers_setcurrent (state, surveymembers_result) {
      state.currentsurveymembers = surveymembers_result.result
    },
    survey_clearcurrent (state) {
      state.currentsurvey_id = 0
      state.currentsurvey = {
        id: 0,
        user_id: 0,
        group_id: 0,
        survey_name: '',
        survey_start_date: '',
        survey_end_date: '',
        survey_type_id: 1,
        survey_status_id: 0,
        survey_normvalues_id: 0,
        survey_language_id: 0,
        survey_invoice_reference: '',
        survey_invitation_subject: '',
        survey_invitation_text: '',
        survey_invitation_consultant_text: '',
        survey_invitation_cc: ''
      }
      state.currentsurveymembers = []
    },
    survey_setmailstatus (state, statusobj) {
      state.surveymailstatus = statusobj.status
    },
    surveys_set (state, surveys_result) {
      state.surveys = surveys_result.result
    },
    surveycount_set (state, surveycounts) {
      state.surveycount_1 = surveycounts.surveycount_1
      state.surveycount_2 = surveycounts.surveycount_2
      state.surveycount_3 = surveycounts.surveycount_3
      state.surveycount_4 = surveycounts.surveycount_4
      state.surveycount_9 = surveycounts.surveycount_9
      state.surveycount_deleted = surveycounts.surveycount_deleted
    },
    groupsurveys_setcurrent (state, groupsurveys_result) {
      state.currentgroupsurveys = groupsurveys_result.result
    },
    // ---------------------
    // Folder Tree handling
    // ---------------------
    foldertree_set (state, foldertree) {
      state.foldertree = foldertree
    },
    // --------
    // Folders
    // --------
    folders_set (state, folders) {
      state.folders = folders.result
    },
    // -------------
    // Survey Types
    // -------------
    surveytypes_set (state, surveytypes) {
      state.surveytypes = surveytypes.result
    },
    // ----------
    // Countries
    // ----------
    countries_set (state, countries) {
      state.countries = countries.result
    },
    // --------------------
    // Consultant statuses
    // --------------------
    consultantstatuses_set (state, consultantstatuses) {
      state.consultantstatuses = consultantstatuses.result
    },
    // ----------
    // Languages
    // ----------
    languages_set (state, languages) {
      state.languages = languages.result
    },
    // ---------------------
    // Norm value countries
    // ---------------------
    normvalues_countries_set (state, normvalues_countries) {
      state.normvalues_countries = normvalues_countries
    },
    // -------------
    // Form options
    // -------------
    formoptions_set (state, formoptions) {
      state.formoptions = formoptions.result
    },
    //= ====================
    // Public Questionnaire
    //= ====================
    questionnaire_setadmin (state, admin) {
      state.questionnaire_admin = admin
    },
    questionnaire_setadmin_code (state, code) {
      state.questionnaire_admin_code = code
    },
    questionnaire_setadmin_done (state, done) {
      state.questionnaire_admin_done = done
    },
    // ------------------------
    // Questionnaire questions
    // ------------------------
    questionnaire_surveymember_token_setcurrent (state, token) {
      state.currentquestionnairetoken = token
    },
    questionnaire_survey_setcurrent (state, survey_id) {
      state.questionnaire_survey_id = survey_id
    },
    questionnaire_survey_set (state, survey) {
      state.questionnaire_survey = survey
    },
    questionnaire_questions_set (state, questions) {
      state.questionnaire_questions = questions
    },
    questionnaire_general_startquestions_set (state, questions) {
      state.questionnaire_startquestions = questions
    },
    questionnaire_general_endquestions_set (state, questions) {
      state.questionnaire_endquestions = questions
    },
    questionnaire_surveymember_setcurrent (state, surveymember_id) {
      state.currentquestionnairemember_id = surveymember_id
    },
    questionnaire_surveymember_set (state, surveymember) {
      state.currentquestionnairemember = surveymember
    },
    questionnaire_consultant_set (state, consultant) {
      state.questionnaire_consultant = consultant
    },
    questionnaire_gdqanswers_set (state, answers) {
      state.currentquestionnairegdqanswers = answers
    },
    netspayment_id_setcurrent (state, current_netspayment_id) {
      state.current_netspayment_id = current_netspayment_id
    },
    currentelearningcourse_id_setcurrent (state, currentcourse_id) {
      state.currentelearningcourse_id = currentcourse_id
    },
    currentelearningstep_id_setcurrent (state, currentstep_id) {
      state.currentelearningstep_id = currentstep_id
    },
    learninghub_my_set (state, my) {
      state.learninghub.my = my
    },
    learninghub_course_set (state, course) {
      state.learninghub.course = course
    },
    learninghub_progress_set (state, progress) {
      state.learninghub.steps_done = progress.steps_done
      state.learninghub.substeps_done = progress.substeps_done
    },
    learninghub_enrolment_set (state, enrolment) {
      state.learninghub.enrolment = enrolment
    },
    learninghub_progress_loaded_set (state, loaded) {
      state.learninghub.progress_loaded = loaded
    },
    learninghub_steps_done_set (state, steps_done) {
      state.learninghub.steps_done = steps_done
    },
    learninghub_substeps_done_set (state, substeps_done) {
      state.learninghub.substeps_done = substeps_done
    },
    learninghub_loading_set (state, loading) {
      state.learninghub.loading = loading
    },
    learninghub_error_set (state, error) {
      state.learninghub.error = error
    }
  },
  //= =======
  // ACTIONS
  //= =======
  actions: {
    serverdate_fetch () {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/serverdate')
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    serverdate_adddays (payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/serverdateadd', payload)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    toggleanon ({ commit }) {
      commit('toggleanon')
    },
    legacyanswers_get (_, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url: base_url + '/gdq_legacyanswers_get/' + payload.surveymember_id,
          method: 'GET'
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    usersystemmessages_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url: base_url + '/gdq_usersystemmessages_get/' + payload.user_id,
          method: 'GET'
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    usersystemmessage_setstatus (_, payload) {
      return new Promise((resolve) => {
        axios
          .post(
            base_url + '/gdq_usersystemmessage_status',
            JSON.stringify(payload),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    setfoldersopen (_, visible) {
      this.commit('setfoldersopen', visible)
    },
    setagreportsopen (_, visible) {
      this.commit('setagreportsopen', visible)
    },
    netspayment_create (_, payload) {
      return new Promise((resolve) => {
        axios
          .post(base_url + '/gdq_netspayment_create', JSON.stringify(payload), {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    netspayment_set ({ commit }, payload) {
      commit('set_current_netspayment_id', payload.current_netspayment_id)
    },
    netspayment_update (_, payload) {
      return new Promise((resolve) => {
        axios
          .post(base_url + '/gdq_nets_update', JSON.stringify(payload), {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    syspref_get (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_sys_pref_get/' + payload.name)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    aggregatedreports_get (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/gdq_gdqagreports_get', payload)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    setcurrentaggregatedreport_id ({ commit }, payload) {
      commit('setcurrentaggregatedreport_id', { report_id: payload.report_id })
    },
    accesslog (payload) {
      // axios.defaults.headers.common['Authorization'] = 'Bearer:' + this.state.token
      return new Promise((resolve) => {
        axios
          .post(base_url + '/accesslog', JSON.stringify(payload), {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    setadmin ({ commit }, payload) {
      localStorage.setItem('gdq_asadmin', payload.asadmin)
      commit('setadmin', { asadmin: payload.asadmin })
    },
    // General mail
    mail_send (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/gdq_mail', JSON.stringify(payload), {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // General CRUD - see if this works
    record_read (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/' + payload.table_name + '/' + payload.id, { headers: { Authorization: 'Bearer:' + (this.state.token.length > 0 ? this.state.token : api_token) } })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    records_readall (_, payload) {
      return new Promise((resolve, reject) => {
        let url = base_url + '/' + payload.table_name
        let sep = '?'
        if (payload.filter) {
          url += sep + 'filter=' + JSON.stringify(payload.filter)
          sep = '&'
        }
        if (payload.orderby) {
          url += sep + 'orderby=' + payload.orderby
          sep = '&'
          if (payload.order) {
            url += sep + 'order=' + payload.order
            sep = '&'
          }
        }
        if (payload.mainfield && payload.mainvalue) {
          url += sep + 'mainfield=' + payload.mainfield
          sep = '&'
          url += sep + 'mainvalue=' + payload.mainvalue
          sep = '&'
        }
        axios
          .get(url, { headers: { Authorization: 'Bearer:' + (this.state.token.length > 0 ? this.state.token : api_token) } })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    record_readlist (_, payload) {
      return new Promise((resolve, reject) => {
        let url = base_url + '/' + payload.table_name + '/list'
        let sep = '?'
        if (payload.filter) {
          url += sep + 'filter=' + JSON.stringify(payload.filter)
          sep = '&'
        }
        if (payload.orderby) {
          url += sep + 'orderby=' + payload.orderby
          sep = '&'
          if (payload.order) {
            url += sep + 'order=' + payload.order
            sep = '&'
          }
        }
        if (payload.limit) {
          url += sep + 'limit=' + payload.limit
          sep = '&'
        }
        if (payload.start) {
          url += sep + 'start=' + payload.start
          sep = '&'
        }
        if (payload.mainfield && payload.mainvalue) {
          url += sep + 'mainfield=' + payload.mainfield
          sep = '&'
          url += sep + 'mainvalue=' + payload.mainvalue
          sep = '&'
        }
        axios
          .get(url, { headers: { Authorization: 'Bearer:' + (this.state.token.length > 0 ? this.state.token : api_token) } })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    record_put (_, payload) {
      return new Promise((resolve) => {
        axios
          .put(
            base_url + '/' + payload.table_name + '/' + payload.id,
            JSON.stringify(payload.record),
            {
              headers: {
                Authorization: 'Bearer:' + (this.state.token.length > 0 ? this.state.token : api_token),
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    record_post (_, payload) {
      return new Promise((resolve) => {
        axios
          .post(
            base_url + '/' + payload.table_name,
            JSON.stringify(payload.record),
            {
              headers: {
                Authorization: 'Bearer:' + (this.state.token.length > 0 ? this.state.token : api_token),
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    record_delete (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(base_url + '/' + payload.table_name + '/' + payload.id, { headers: { Authorization: 'Bearer:' + (this.state.token.length > 0 ? this.state.token : api_token) } })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    async image_get (_, payload) {
      const url =
        base_url +
        '/' +
        payload.table_name +
        '/image/' +
        payload.field_name +
        '/' +
        payload.id
      const config = { url, method: 'get', responseType: 'blob' }
      const response = await axios.request(config)
      return response.data // the blob
    },
    // -----------------------------------------------
    // Save a field to a table with an id and a value
    // -----------------------------------------------
    field_save (_, payload) {
      return new Promise((resolve) => {
        axios
          .put(
            base_url + '/' + payload.tablename + '/' + payload.record.id,
            JSON.stringify(payload.record),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    switchto ({ commit }, payload) {
      const token = payload.token
      // Fix this later
      // const user = resp.data.token;
      let tokenParts = token.split('.')
      tokenParts = tokenParts[1]
      tokenParts = atob(tokenParts)
      tokenParts = JSON.parse(tokenParts)
      const user_id = tokenParts.id
      localStorage.setItem('gdq_token', token)
      commit('auth_success', { token, user_id })
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_profile/' + this.state.user_id)
          .then((resp) => {
            commit('profile_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    excludedquestions_save (_, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url: base_url + '/gdq_excludedquestions_save',
          method: 'POST',
          data: payload
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    excludedquestions_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url: base_url + '/gdq_excludedquestions_get/' + payload.survey_id,
          method: 'GET'
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    paperform_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url: base_url + '/gdq_paperform_get/' + payload.surveymember_id,
          method: 'GET'
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    paperforms_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url: base_url + '/gdq_paperforms_get/' + payload.survey_id,
          method: 'GET'
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    systemscreenelements_fetch (_, payload) {
      const filter = payload.filter
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/g_systemscreenelements?' +
              'filter=' +
              JSON.stringify(filter) +
              '&orderby=element_name'
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // Get speech bubble text
    bubbletext_fetch (_, payload) {
      const filter = {
        screen_id: {
          operator: '=',
          value: payload.screen_id
        },
        screenelement_id: {
          operator: '=',
          value: payload.screenelement_id
        }
      }
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_bubbletexts?filter=' + JSON.stringify(filter))
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // -----------------
    // Login and logout
    // -----------------
    login ({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({
          url: base_url + '/login',
          data: user,
          method: 'POST'
        })
          .then((resp) => {
            // if (
            //   resp.headers['x-two-factor-required'] === 'true' ||
            //   resp.headers['x-two-factor-required'] === 'true' ||
            //   resp.headers['x-two-factor-email-required'] === 'true'
            // ) {

            // }
            const token = resp.data.token
            // Fix this later
            // const user = resp.data.token;
            let payload = token.split('.')
            payload = payload[1]
            payload = atob(payload)
            payload = JSON.parse(payload)
            const user_id = payload.id
            localStorage.setItem('gdq_token', token)
            commit('auth_success', { token, user_id })
            resolve(resp)
          })
          .catch((err) => {
            commit('auth_error')
            localStorage.removeItem('gdq_token')
            reject(err)
          })
      })
    },
    lastlogin_set (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_lastlogin_set/' + payload.id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    logout ({ commit }) {
      return new Promise((resolve) => {
        commit('logout')
        localStorage.removeItem('gdq_token')
        delete axios.defaults.headers.common.Authorization
        resolve()
      })
    },
    mygdqpage_setreload ({ commit }, payload) {
      return new Promise((resolve) => {
        commit('mygdqpage_setreload', payload.reload)
        resolve()
      })
    },
    surveymembers_setreload ({ commit }, payload) {
      return new Promise((resolve) => {
        commit('surveymembers_setreload', payload.reload)
        resolve()
      })
    },
    // -----------------
    // User and Profile
    // -----------------
    user_fetch ({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/i_user/' + this.state.user_id)
          .then((resp) => {
            commit('user_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    profile_fetch ({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_profile/' + this.state.user_id)
          .then((resp) => {
            commit('profile_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    consultant_mailpreferences_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_api_cmp_get/' + payload.subscription_token, { headers: { Authorization: 'Bearer:' + api_token } })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    consultant_mailpreferences_save (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/gdq_api_cmp_save', payload, { headers: { Authorization: 'Bearer:' + api_token } })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    user_usergroups_fetch ({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/i_user_usergroup?user_id=' + this.state.user_id)
          .then((resp) => {
            commit('user_usergroups_set', resp.data.result)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // ---------------
    // Team dashboard
    // ---------------
    teamdashboard_surveys_fetch (context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_enterprise_surveys', { params: payload })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    teamdashboard_teams_in_stages_fetch (context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_enterprise_teams_in_stages', { params: payload })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    teamdashboard_stage_distribution_fetch (context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_enterprise_stage_distribution', { params: payload })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    teamdashboard_percentiles_fetch (context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_enterprise_percentiles', { params: payload })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    teamdashboard_group_stats_fetch (context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_enterprise_group_stats', { params: payload })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    teamdashboard_export_excel (context, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url: base_url + '/gdq_enterprise_export_excel',
          method: 'POST',
          responseType: 'blob',
          data: JSON.stringify(payload)
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    user_save (_, payload) {
      axios.put(
        base_url + '/i_user/' + this.state.user_id,
        JSON.stringify(payload.user),
        {
          headers: {
            Accept: 'application/json',
            'Content-type': 'application/json'
          }
        }
      )
    },
    resetpassword_save (_, payload) {
      return axios.put(
        base_url + '/resetpassword_save/' + payload.user.id,
        JSON.stringify(payload.user),
        {
          headers: {
            Accept: 'application/json',
            'Content-type': 'application/json'
          }
        }
      )
    },
    async profile_save ({ dispatch }, payload) {

      await axios.put(
        base_url + '/g_profile/' + this.state.user_id,
        JSON.stringify(payload.profile),
        {
          headers: {
            Accept: 'application/json',
            'Content-type': 'application/json'
          }
        }
      )

      await dispatch('profile_fetch')

      await axios.put(
        base_url + '/i_user/' + this.state.user_id,
        JSON.stringify(payload.user),
        {
          headers: {
            Accept: 'application/json',
            'Content-type': 'application/json'
          }
        }
      )

      return dispatch('user_fetch')
    },
    forgotpassword (_, payload) {
      const filter = payload.filter
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/forgotpassword?filter=' +
              JSON.stringify(filter) +
              '&a=0'
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    userbytoken_fetch (_, payload) {
      const token = payload.token
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/userbytoken?t=' + token)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // ----------
    // Tutorials
    // ----------
    tutorials_fetch () {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_tutorials')
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    tutorial_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_tutorials/' + payload.tutorial_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    tutorial_setcurrent ({ commit }, payload) {
      return new Promise((resolve) => {
        commit('tutorial_setcurrent', payload.tutorial_id)
        resolve(true)
      })
    },
    // ----------
    // Materials
    // ----------
    material_fetch (_, payload) {
      return new Promise((resolve) => {
        axios
          .get(base_url + '/g_materials/' + payload.material_id, '', {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    materials_fetch (_, payload) {
      const filter = payload.filter
      const start = payload.start
      const limit = payload.limit
      const orderby = payload.orderby
      const order = payload.order
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/g_materials?' +
              'filter=' +
              JSON.stringify(filter) +
              '&start=' +
              start +
              '&limit=' +
              limit +
              '&orderby=' +
              orderby +
              '&order=' +
              order
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    material_setcurrent ({ commit }, payload) {
      return new Promise((resolve) => {
        commit('material_setcurrent', payload.material_id)
        resolve(true)
      })
    },
    // ----------
    // e-Learning
    // ----------
    elearning_vtoken () {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_getvtoken')
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    elearningmaterial_fetch (_, payload) {
      return new Promise((resolve) => {
        axios
          .get(base_url + '/g_elearning_materials/' + payload.material_id, '', {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    elearningmaterials_fetch (_, payload) {
      const filter = payload.filter
      const start = payload.start
      const limit = payload.limit
      const orderby = payload.orderby
      const order = payload.order
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/g_elearning_materials?' +
              'filter=' +
              JSON.stringify(filter) +
              '&start=' +
              start +
              '&limit=' +
              limit +
              '&orderby=' +
              orderby +
              '&order=' +
              order
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    elearningstep_update (_, payload) {
      return new Promise((resolve) => {
        axios
          .post(
            base_url + '/gdq_consultant_el_update_step',
            JSON.stringify(payload),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    elearning_consultantstatus (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_consultant_el_status/' + payload.course_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    elearning_consultant_getcourses (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url + '/gdq_el_consultant_getcourses/' + payload.consultant_id
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    elearning_consultant_course_getmodules (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/gdq_el_consultant_course_getmodules/' +
              payload.consultant_id +
              '/' +
              payload.course_id
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    elearning_consultant_module_getsteps (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/gdq_el_consultant_module_getsteps/' +
              payload.consultant_id +
              '/' +
              payload.module_id
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    elearning_allanswers_save (_, payload) {
      return new Promise((resolve) => {
        axios
          .post(
            base_url + '/gdq_consultant_el_answers_save',
            JSON.stringify(payload),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    elearning_exam_check (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            base_url + '/gdq_consultant_el_exam_check',
            JSON.stringify(payload),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // -------
    // Groups
    // -------
    group_setcurrent ({ commit }, group_id) {
      return new Promise((resolve) => {
        commit('group_setcurrent', group_id)
        resolve(true)
      })
    },
    groups_fetch ({ commit }) {
      const filter = {
        group_deleted: {
          operator: '=',
          value: 0
        }
      }
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/g_groups?orderby=group_name&filter=' +
              JSON.stringify(filter)
          )
          .then((resp) => {
            commit('groups_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // ------
    // Group
    // ------
    group_fetch ({ dispatch, commit }) {
      return new Promise((resolve, reject) => {
        commit('group_setloadstatus', 1)
        axios
          .get(base_url + '/g_groups/' + this.state.currentgroup_id)
          .then((resp) => {
            commit('group_set', resp.data)
            commit('group_setloadstatus', 0)
            dispatch('groupmembers_fetch', {
              group_id: this.state.currentgroup_id
            })
            dispatch('groupsurveys_fetch', {
              group_id: this.state.currentgroup_id
            })
            resolve(resp)
          })
          .catch((err) => {
            commit('group_setloadstatus', 2)
            reject(err)
          })
      })
    },
    group_create ({ dispatch, commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/g_groups', JSON.stringify(payload.group), {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            commit('group_setcurrent', resp.data.id)
            dispatch('group_fetch').then((resp) => {
              resolve(resp)
            })
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    group_save (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            base_url + '/g_groups/' + payload.group.id,
            JSON.stringify(payload.group),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    group_clear ({ commit }) {
      commit('group_clearcurrent')
    },
    // --------------
    // Group Members
    // --------------
    groupmembers_fetch ({ commit }, payload) {
      if (payload.group_id && payload.group_id !== 0) {
        const filter = {
          group_id: {
            operator: '=',
            value: payload.group_id
          },
          groupmember_deleted: {
            operator: '=',
            value: 0
          }
        }
        return new Promise((resolve, reject) => {
          axios
            .get(base_url + '/g_groupmembers?filter=' + JSON.stringify(filter))
            .then((resp) => {
              commit('groupmembers_setcurrent', resp.data)
              resolve(resp)
            })
            .catch((err) => {
              reject(err)
            })
        })
      } else {
        commit('groupmembers_setcurrent', [])
        // resolve([])
      }
    },
    groupmembers_upload (_, payload) {
      // ---------------------------------------------------
      // Payload is a formdata object with the field "file"
      // for the file to upload
      // ---------------------------------------------------
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/gdq_groupmembersupload', payload, {
            headers: {
              Accept: 'application/json',
              'Content-type': 'multipart/form-data'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupmembers_create ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/gdq_groupmemberscreate', JSON.stringify(payload), {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then(() => {
            dispatch('group_fetch').then((resp) => {
              resolve(resp)
            })
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // Create New Group Member
    groupmember_create (_, payload) {
      return new Promise((resolve) => {
        axios
          .post(
            base_url + '/g_groupmembers',
            JSON.stringify(payload.groupmember),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    // Delete Group Member
    groupmember_delete (_, payload) {
      return new Promise((resolve) => {
        axios
          .get(base_url + '/gdq_groupmember_delete/' + payload.id, '', {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    groupmember_save (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            base_url + '/g_groupmembers/' + payload.groupmember.id,
            JSON.stringify(payload.groupmember),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // Flag for adding survey member
    addingsurveymember_set ({ commit }, payload) {
      commit('addingsurveymember_set', {
        addingsurveymember: payload.addingsurveymember
      })
    },
    // -------------
    // Group Labels
    // -------------
    grouplabels_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_consultantgrouplabels/' + payload.group_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    grouplabel_add (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            base_url + '/gdq_consultantgrouplabel_save',
            JSON.stringify(payload.label),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    grouplabel_delete (_, payload) {
      return new Promise((resolve) => {
        axios
          .delete(
            base_url + '/gdq_consultantgrouplabel_delete/' + payload.id,
            '',
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    // -------------------------
    // All Consultant's Surveys
    // -------------------------
    surveycount_set ({ commit }, payload) {
      commit('surveycount_set', payload)
    },
    surveys_fetch ({ commit }, payload) {
      const limit = payload.limit ? payload.limit : 0
      const start = payload.start ? payload.start : 0
      const countonly = payload.countonly ? payload.countonly : false
      const url =
        base_url +
        '/gdq_surveys_get?filter=' +
        JSON.stringify(payload.filter) +
        '&limit=' +
        limit +
        '&start=' +
        start +
        (countonly === true ? '&countonly' : '')
      return new Promise((resolve, reject) => {
        axios
          .get(url, JSON.stringify(payload))
          .then((resp) => {
            commit('surveys_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    surveycount_fetch (payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_surveys_get_count', JSON.stringify(payload))
          .then((resp) => {
            // commit('surveys_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // --------------------------------------
    // Group Surveys - get all for the group
    // --------------------------------------
    groupsurveys_fetch ({ commit }, payload) {
      const start = payload.start || 0
      const limit = payload.limit || 1000
      const orderBy = payload.orderBy || 'survey_start_date'
      const orderDesc = payload.orderDesc !== undefined ? payload.orderDesc : true
      return new Promise((resolve, reject) => {
        const filter = {
          group_id: {
            operator: '==',
            value: payload.group_id
          }
        }
        const url = base_url + '/gdq_surveys_get?filter=' + JSON.stringify(filter) +
          '&limit=' + limit + '&start=' + start +
          '&orderBy=' + orderBy + '&orderDesc=' + orderDesc
        axios
          .get(url)
          .then((resp) => {
            commit('groupsurveys_setcurrent', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurvey_setcurrent ({ commit, dispatch }, payload) {
      commit('survey_setcurrent', payload.survey_id)
      return new Promise((resolve) => {
        dispatch('groupsurvey_fetch').then((resp) => {
          resolve(resp)
        })
      })
    },
    groupsurvey_setbusy ({ commit }, payload) {
      commit('survey_setbusy', payload.survey_id)
      return true
    },
    // --------
    // Get one
    // --------
    groupsurvey_wipe (_, payload) {
      return new Promise((resolve) => {
        axios
          .post(base_url + '/gdq_survey_wipe', JSON.stringify(payload), {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    groupsurvey_fetch ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_survey_get/' + this.state.currentsurvey_id)
          .then((resp) => {
            commit('survey_set', resp.data)
            commit('group_setcurrent', resp.data.group_id)
            dispatch('groupsurveymembers_fetch', {
              survey_id: this.state.currentsurvey_id
            })
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurvey_update (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            base_url + '/g_surveys/' + payload.survey.id,
            JSON.stringify(payload.survey),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurvey_changelanguage (_, payload) {
      return new Promise((resolve) => {
        axios
          .post(
            base_url + '/gdq_groupsurvey_changelanguage',
            JSON.stringify(payload),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    groupsurvey_save ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            base_url + '/gdq_survey_save/' + payload.survey.id,
            JSON.stringify(payload.survey),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            commit('survey_setcurrent', resp.data.id ?? payload.survey.id)
            resolve(dispatch('groupsurvey_fetch'))
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurvey_create ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/g_surveys', JSON.stringify(payload), {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            commit('survey_setcurrent', resp.data.id)
            dispatch('groupsurvey_fetch').then((resp) => {
              resolve(resp)
            })
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurvey_launch ({ dispatch }, payload) {
      const survey = payload.survey
      dispatch('groupsurvey_save', { survey })
    },
    groupsurvey_close (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/gdq_groupsurveyclose', JSON.stringify(payload), {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurvey_anonymize (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/gdq_survey_anonymize', JSON.stringify(payload), {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurveyinvoice_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_get_gdq_invoice/' + payload.survey_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    aggregatedinvoice_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_get_aggr_invoice/' + payload.report_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurveyinvoice_save (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            base_url + '/g_consultantinvoices/' + payload.invoice_id,
            JSON.stringify(payload.invoice),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurveymailqueue_fetch (_, payload) {
      const filter = payload.filter ? payload.filter : ''
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/gdq_surveymailqueue_get/' +
              payload.survey_id +
              '?filter=' +
              JSON.stringify(filter)
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // -----------------------------------------------------------
    // Send e-mail notification to admin - new invoice is created
    // -----------------------------------------------------------
    groupsurveyinvoice_notifyadmin (_, payload) {
      return new Promise((resolve) => {
        axios
          .post(base_url + '/gdq_invoice_notify', JSON.stringify(payload), {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            resolve(err)
            // FIX - get CORS error when running on bjorn-ubuntu-dbweb
            // reject(err)
          })
      })
    },
    gdqreport_get (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_gdqreport_get/' + payload.survey_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    gdqreport_create (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_gdqreport_create/' + payload.survey_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    gdqreport_create_v2 (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_gdqreport_create_v2/' + payload.survey_id + '?v2=true')
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    gdqshortreport_create_v2 (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_gdqshortreport_create_v2/' + payload.survey_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    gdqagreport_save (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/gdq_aggregatedreport_save', payload, {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    gdqagreport_create (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/gdq_aggregatedreport_create', payload, {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    gdqagshortreport_create (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/gdq_aggregatedshortreport_create', payload, {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    gdqshortreport_get (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_gdqshortreport_get/' + payload.survey_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    gdqshortreport_spotify_get (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url + '/gdq_gdqshortreport_spotify_get/' + payload.survey_id
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    gdqshortreport_create (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_gdqshortreport_create/' + payload.survey_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    gdqshortreport_spotify_create (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url + '/gdq_gdqshortreport_spotify_create/' + payload.survey_id
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    oscreport_get (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_oscreport_get/' + payload.survey_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    oscreport_create (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_oscreport_create/' + payload.survey_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    gdqreport_rawdata_get (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_rawdata_get/' + payload.survey_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    gdqreport_rawdata_excel_get (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/gdq_rawdata_excel_get/' +
              payload.survey_id +
              '/' +
              payload.full,
            {
              responseType: 'blob' // ✅ Tell axios to expect binary file
            }
          )
          .then((resp) => resolve(resp))
          .catch((err) => reject(err))
      })
    },
    gdqreport_receipt_create (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_receipt_create/' + payload.survey_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    google_drive_upload (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/google_drive_upload', { report_id: payload.report_id })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    gdqagreport_receipt_create (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_agreceipt_create/' + payload.invoice_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurvey_mail ({ commit }, payload) {
      commit('survey_setmailstatus', { status: 1 })
      return axios.post(
        base_url + '/gdq_groupsurveymembersmail',
        JSON.stringify(payload),
        {
          headers: {
            Accept: 'application/json',
            'Content-type': 'application/json'
          }
        }
      )
    },
    survey_setmailstatus ({ commit }, statusobj) {
      commit('survey_setmailstatus', statusobj)
    },
    survey_clear ({ commit }) {
      commit('survey_clearcurrent')
    },
    groupsurveys_setselected ({ commit }, payload) {
      commit('surveys_setselected', payload.surveys)
    },
    // --------------------
    // Group Survey Stages
    // --------------------
    groupsurveystages_fetch () {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_stages')
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // --------------------
    // Group Survey Labels
    // --------------------
    groupsurveylabels_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_consultantsurveylabels/' + payload.survey_id)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurveylabel_add (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            base_url + '/gdq_consultantsurveylabel_save',
            JSON.stringify(payload.label),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurveylabel_delete (_, payload) {
      return new Promise((resolve) => {
        axios
          .delete(
            base_url + '/gdq_consultantsurveylabel_delete/' + payload.id,
            '',
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    // ---------------------
    // Group Survey Members
    // ---------------------
    groupsurveymember_fetch (_, payload) {
      return new Promise((resolve) => {
        axios
          .get(base_url + '/g_surveymembers/' + payload.id, '', {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    groupsurveymember_remove (_, payload) {
      return new Promise((resolve) => {
        axios
          .get(base_url + '/gdq_groupsurveymember_remove/' + payload.id, '', {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    groupsurveymembers_setselected ({ commit }, payload) {
      commit('surveymembers_setselected', payload.surveymembers)
    },
    groupsurveymembers_create ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            base_url + '/gdq_groupsurveymemberscreate',
            JSON.stringify(payload),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            const survey_id = resp.data?.survey_id ?? payload.survey_id ?? this.state.currentsurvey_id
            const group_id = resp.data?.group_id ?? payload.group_id ?? this.state.currentgroup_id
            commit('survey_setcurrent', survey_id)
            dispatch('groupmembers_fetch', {
              group_id
            }).then(() => {
              dispatch('groupsurvey_fetch', { id: survey_id }).then(() => {
                resolve(resp)
              })
            })
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurveymembers_addnewgroupmembers (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            base_url + '/gdq_groupsurveymembers_addnewgroupmembers',
            JSON.stringify(payload),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurveyandgroupmembers_fetch ({ dispatch }, payload) {
      let group_id = null
      let survey_id = null
      survey_id = payload.survey_id
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_groupsurveyandgroupmembers_get/' + survey_id)
          .then((resp) => {
            if (resp.data.result.length !== 0) {
              for (let i = 0; i < resp.data.result.length; i++) {
                group_id = resp.data.result[i].group_id
              }
            }
            dispatch('groupsurveymembers_fetch', { survey_id }).then(
              () => {
                dispatch('groupmembers_fetch', { group_id })
              }
            )
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    groupsurveymembers_fetch ({ commit }, payload) {
      const filter = {
        survey_id: {
          operator: '=',
          value: payload.survey_id
        }
      }
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_surveymembers?filter=' + JSON.stringify(filter))
          .then((resp) => {
            commit('surveymembers_setcurrent', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // --------------------
    // Survey activity log
    // --------------------
    activitylog_fetch (_, payload) {
      const orderby = payload.orderby
      const order = payload.order
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/gdq_groupsurveylog_get' +
              '?filter=' +
              JSON.stringify(payload.filter) +
              '&orderby=' +
              orderby +
              '&order=' +
              order
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // --------------
    // Create Folder
    // --------------
    folder_create (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/g_folders', JSON.stringify(payload.folder), {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    folder_save (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            base_url + '/g_folders/' + payload.folder.id,
            JSON.stringify(payload.folder),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // ------------
    // Folder Tree
    // ------------
    treeitem_save (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            base_url + '/gdq_savetreeitem/' + payload.id,
            JSON.stringify(payload.body),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    foldertree_fetch ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const type = payload && payload.type ? payload.type : ''
        const search = payload && payload.search ? payload.search : ''
        const limit = payload && payload.limit ? payload.limit : 0
        const drag = payload && payload.drag ? payload.drag : 0
        axios
          .get(
            base_url +
              '/gdq_folders/' +
              this.state.user_id +
              '?type=' +
              type +
              '&search=' +
              search +
              '&limit=' +
              limit +
              '&drag=' +
              drag
          )
          .then((resp) => {
            commit('foldertree_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // --------
    // Folders
    // --------
    folders_fetch ({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_folders')
          .then((resp) => {
            commit('folders_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // -------------
    // Survey Types
    // -------------
    surveytypes_fetch ({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_surveytypes')
          .then((resp) => {
            commit('surveytypes_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // ----------
    // Countries
    // ----------
    countries_fetch ({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_countries')
          .then((resp) => {
            commit('countries_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // ----------
    // Countries
    // ----------
    consultantstatuses_fetch ({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_consultantstatus', { headers: { Authorization: 'Bearer:' + api_token } })
          .then((resp) => {
            commit('consultantstatuses_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // ----------
    // Languages
    // ----------
    languages_fetch ({ commit }) {
      const filter = {
        language_enabled: {
          operator: '=',
          value: 1
        }
      }
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_languages?filter=' + JSON.stringify(filter))
          .then((resp) => {
            commit('languages_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // ---------------------
    // Normvalues countries
    // ---------------------
    normvalues_countries_fetch ({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_normvalues_countries')
          .then((resp) => {
            commit('normvalues_countries_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // -------------
    // Form options
    // -------------
    formoptions_fetch ({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_formoptions')
          .then((resp) => {
            commit('formoptions_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    //= =========
    // CHECKLIST
    //= =========
    checklistquestions_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/gdq_checklist_all_questions?language=' +
              payload.language_id,
            { headers: { Authorization: 'Bearer:' + api_token } }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    //= ====================
    // Public Questionnaire
    //= ====================
    // ---------------
    // Set Admin flag
    // ---------------
    questionnaire_setadmin ({ commit }, payload) {
      return new Promise((resolve) => {
        commit('questionnaire_setadmin', payload.admin)
        resolve()
      })
    },
    questionnaire_setadmin_code ({ commit }, payload) {
      return new Promise((resolve) => {
        commit('questionnaire_setadmin_code', payload.code)
        resolve()
      })
    },
    questionnaire_setadmin_done ({ commit }, payload) {
      return new Promise((resolve) => {
        commit('questionnaire_setadmin_done', payload.done)
        resolve()
      })
    },
    // ------------------------
    // Get Questionnaire Texts
    // ------------------------
    questionnairetexts_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_questionnairetexts/' + payload.language_id, { headers: { Authorization: 'Bearer:' + api_token } })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    //= ==================
    // ADD-ON SURVEY HERE
    //= ==================
    gdq_addonsurvey_saveanswers (_, payload) {
      return new Promise((resolve) => {
        axios
          .post(
            base_url + '/gdq_addonsurvey_saveanswers',
            JSON.stringify(payload),
            {
              headers: {
                Authorization: 'Bearer:' + api_token,
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    gdq_addonsurvey_get (_, payload) {
      return new Promise((resolve) => {
        axios
          .get(
            base_url + '/gdq_addonsurvey_get?addonsurvey_id=' + payload.addonsurvey_id,
            {
              headers: {
                Authorization: 'Bearer:' + api_token,
                Accept: 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    gdq_addonsurvey_exportexcel (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            base_url + '/gdq_addonsurvey_exportexcel',
            { survey_id: payload.survey_id },
            { responseType: 'blob' }
          )
          .then((resp) => resolve(resp))
          .catch((err) => reject(err))
      })
    },
    //= ======================
    // NEW QUESTIONNAIRE HERE
    //= ======================
    questionnaire_surveymember_setstatus (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            base_url + '/g_surveymembers/' + payload.surveymember.id,
            JSON.stringify(payload.surveymember),
            {
              headers: {
                Authorization: 'Bearer:' + api_token,
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // ----------------------------------
    // Questionnaire ALL questions - NEW
    // ----------------------------------
    questionnaire_gdqshortallquestions_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/gdq_questionnaire_all_questions/' +
              payload.survey_id +
              '?language=' +
              payload.language_id,
            { headers: { Authorization: 'Bearer:' + api_token } }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    questionnaire_gdqallquestions_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/gdq_questionnaire_all_questions/' +
              payload.survey_id +
              '?language=' +
              payload.language_id,
            { headers: { Authorization: 'Bearer:' + api_token } }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // Control Questions OSC
    osccontrolquestions_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/gdq_questionnaire_controlquestions/' +
              payload.survey_id +
              '?language=' +
              payload.language_id,
            { headers: { Authorization: 'Bearer:' + api_token } }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    questionnaire_gdqsurveymember_fetch (_, payload) {
      const token = payload.filter.groupsurveymember_token.value
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url + '/gdq_questionnaire_member?token=' + encodeURIComponent(token),
            { headers: { Authorization: 'Bearer:' + api_token } }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    questionnaire_gdqsurvey_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_surveys/' + payload.survey_id, { headers: { Authorization: 'Bearer:' + api_token } })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    questionnaire_gdqconsultant_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/i_user/' + payload.user_id, { headers: { Authorization: 'Bearer:' + api_token } })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    questionnaire_gdqallanswers_save (_, payload) {
      // Use a real token when present (admins), otherwise fall back to the public api_token
      const authToken = this.state.token && this.state.token.length > 0
        ? this.state.token
        : api_token
      return new Promise((resolve) => {
        axios
          .post(
            base_url + '/gdq_questionnaire_save_answers',
            JSON.stringify(payload),
            {
              headers: {
                Authorization: 'Bearer:' + authToken,
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    //= =====================
    // END NEW QUESTIONNAIRE
    //= =====================
    // --------------------------------
    // Questionnaire General Questions
    // --------------------------------
    questionnaire_gdqgeneralstartquestions_fetch ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/gdq_questionnaire_general_questions/' +
              payload.survey_id +
              '/' +
              payload.sequence +
              '?language=' +
              payload.language_id,
            { headers: { Authorization: 'Bearer:' + api_token } }
          )
          .then((resp) => {
            commit('questionnaire_general_startquestions_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    questionnaire_gdqgeneralendquestions_fetch ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/gdq_questionnaire_general_questions/' +
              payload.survey_id +
              '/' +
              payload.sequence +
              '?language=' +
              payload.language_id,
            { headers: { Authorization: 'Bearer:' + api_token } }
          )
          .then((resp) => {
            commit('questionnaire_general_endquestions_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // ----------------------------
    // Questionnaire GDQ Questions
    // ----------------------------
    questionnaire_gdqquestions_fetch ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/gdq_questionnaire_questions/' +
              payload.surveytype_id +
              '?language=' +
              payload.language_id,
            { headers: { Authorization: 'Bearer:' + api_token } }
          )
          .then((resp) => {
            commit('questionnaire_questions_set', resp.data.questions)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // --------------------------------
    // Questionnaire clear GDQ Answers
    // --------------------------------
    questionnaire_gdqquestionanswers_clear ({ commit }) {
      const statanswers = []
      commit('questionnaire_gdqanswers_set', statanswers)
      return true
    },
    // -------------------------------
    // Questionnaire Save GDQ Answers
    // -------------------------------
    questionnaire_gdqquestionanswers_save ({ commit }, payload) {
      return new Promise((resolve) => {
        axios
          .post(
            base_url + '/gdq_questionnaire_gdqanswers_save',
            JSON.stringify(payload),
            {
              headers: {
                Authorization: 'Bearer:' + api_token,
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            const answers = payload.answers
            const statanswers = new Array()
            for (let i = 0; i < answers.length; i++) {
              const answer = {
                id: i,
                surveymember_id: this.state.currentquestionnairemember_id,
                question_id: answers[i].question_id,
                surveymembergdqanswer: answers[i].answer
              }
              statanswers.push(answer)
            }
            commit('questionnaire_gdqanswers_set', statanswers)
            resolve(resp)
          })
      })
    },
    // -------------------------------
    // Questionnaire Read GDQ Answers
    // -------------------------------
    questionnaire_gdqquestionanswers_fetch (_, payload) {
      const filter = {
        surveymember_id: {
          operator: '=',
          value: payload.surveymember_id
        }
      }
      return new Promise((resolve) => {
        axios
          .get(
            base_url +
              '/g_surveymembergdqanswers?filter=' +
              JSON.stringify(filter),
            { headers: { Authorization: 'Bearer:' + api_token } }
          )
          .then((resp) => {
            resolve(resp.data.result)
          })
      })
    },
    // -----------------------------------
    // Questionnaire Save General Answers
    // -----------------------------------
    questionnaire_generalquestionanswers_save (_, payload) {
      return new Promise((resolve) => {
        axios
          .post(
            base_url + '/gdq_questionnaire_generalanswers_save',
            JSON.stringify(payload),
            {
              headers: {
                Authorization: 'Bearer:' + api_token,
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
      })
    },
    // -----------------------------------
    // Questionnaire Read General Answers
    // -----------------------------------
    questionnaire_generalquestionanswers_fetch (_, payload) {
      const filter = {
        surveymember_id: {
          operator: '=',
          value: payload.surveymember_id
        }
      }
      return new Promise((resolve) => {
        axios
          .get(
            base_url +
              '/g_surveymembergeneralanswers?filter=' +
              JSON.stringify(filter),
            { headers: { Authorization: 'Bearer:' + api_token } }
          )
          .then((resp) => {
            resolve(resp.data.result)
          })
      })
    },
    // -----------------------------
    // Questionnaire token handling
    // -----------------------------
    questionnaire_token_set ({ commit }, payload) {
      commit('questionnaire_surveymember_token_setcurrent', payload.token)
      return true
    },
    questionnaire_questionnaire_verify ({ commit, dispatch }, payload) {
      const filter = {
        groupsurveymember_token: {
          operator: '=',
          value: payload.token
        }
      }
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_surveymembers?filter=' + JSON.stringify(filter), { headers: { Authorization: 'Bearer:' + api_token } })
          .then((resp) => {
            const list = resp.data.result
            let questionnairesurvey_id = 0
            let currentquestionnairemember_id = 0
            if (list.length === 1) {
              questionnairesurvey_id = list[0].survey_id
              currentquestionnairemember_id = list[0].id
            }
            dispatch('questionnaire_survey_setcurrent', {
              survey_id: questionnairesurvey_id
            }).then(() => {
              commit(
                'questionnaire_surveymember_setcurrent',
                currentquestionnairemember_id
              )
              resolve(resp)
            })
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    questionnaire_survey_setcurrent ({ commit, dispatch }, payload) {
      commit('questionnaire_survey_setcurrent', payload.survey_id)
      return dispatch('questionnaire_survey_fetch')
    },
    questionnaire_survey_fetch ({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_surveys/' + this.state.questionnaire_survey_id, { headers: { Authorization: 'Bearer:' + api_token } })
          .then((resp) => {
            commit('questionnaire_survey_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    questionnaire_consultant_fetch ({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/i_user/' + this.state.questionnaire_survey.user_id, { headers: { Authorization: 'Bearer:' + api_token } })
          .then((resp) => {
            commit('questionnaire_consultant_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    questionnaire_surveymember_fetch ({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            base_url +
              '/g_surveymembers/' +
              this.state.currentquestionnairemember_id,
            { headers: { Authorization: 'Bearer:' + api_token } }
          )
          .then((resp) => {
            commit('questionnaire_surveymember_set', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            commit('group_setloadstatus', 2)
            reject(err)
          })
      })
    },
    questionnaire_surveymember_validate ({ commit }, payload) {
      const filter = {
        groupsurveymember_token: {
          operator: '=',
          value: payload.token
        },
        groupsurveymember_survey_code: {
          operator: '=',
          value: payload.survey_code
        }
      }
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_surveymembers?filter=' + JSON.stringify(filter), { headers: { Authorization: 'Bearer:' + api_token } })
          .then((resp) => {
            const list = resp.data.result
            let surveymember_id = 0
            if (list.length === 1) {
              surveymember_id = list[0].id
            }
            commit('questionnaire_surveymember_setcurrent', surveymember_id)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    questionnaire_surveymember_save ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            base_url +
              '/g_surveymembers/' +
              this.state.currentquestionnairemember_id,
            JSON.stringify(payload.surveymember),
            {
              headers: {
                Authorization: 'Bearer:' + api_token,
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then(() => {
            dispatch('questionnaire_surveymember_fetch').then((resp) => {
              resolve(resp)
            })
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    //= ========
    // Payments
    //= ========
    // ----------------------------------
    // Create payment attempt log record
    // ----------------------------------
    paymentlog_create (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(base_url + '/gdq_paymentlog_create', JSON.stringify(payload), {
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/json'
            }
          })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    //= ==========
    // E-LEARNING
    //= ==========
    elearning_courses_fetch () {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/g_elearning_courses')
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    currentcourse_id_setcurrent (_, payload) {
      this.commit('currentelearningcourse_id_setcurrent', payload.course_id)
      return true
    },
    currentstep_id_setcurrent (_, payload) {
      this.commit('currentelearningstep_id_setcurrent', payload.step_id)
    },
    // -----------------
    // Event booking
    // -----------------
    event_get (_, payload) {
      return new Promise((resolve, reject) => {
        axios
           .get(base_url + '/gdq_event_get/' + payload.id + '?lang=' + payload.lang, { headers: { Authorization: 'Bearer:' + (this.state.token.length > 0 ? this.state.token : api_token) } })
           .then((resp) => {
             resolve(resp)
           })
           .catch((err) => {
             reject(err)
           })
       })
     },
     eventtexts_fetch (_, payload) {
       return new Promise((resolve, reject) => {
         axios
           .get(base_url + '/gdq_eventtexts/' + payload.lang, { headers: { Authorization: 'Bearer:' + (this.state.token.length > 0 ? this.state.token : api_token) } })
           .then((resp) => {
             resolve(resp)
           })
           .catch((err) => {
             reject(err)
           })
       })
     },
     event_categories_get (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_event_categories?lang=' + payload.lang, { headers: { Authorization: 'Bearer:' + (this.state.token.length > 0 ? this.state.token : api_token) } })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    event_userexists (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_user_exists?email=' + encodeURIComponent(payload.email), { headers: { Authorization: 'Bearer:' + api_token } })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    learninghub_my_fetch () {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_learninghub_my')
          .then((resp) => {
            this.commit('learninghub_my_set', resp.data.result)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    learninghub_course_fetch (_, payload) {
      this.commit('learninghub_loading_set', true)
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_learninghub_course/' + payload.slug)
          .then((resp) => {
            this.commit('learninghub_course_set', resp.data.result)
            resolve(resp)
          })
          .catch((err) => {
            this.commit('learninghub_course_set', null)
            this.commit('learninghub_error_set', err)
            reject(err)
          })
      }).finally(() => {
        this.commit('learninghub_loading_set', false)
      })
    },
    learninghub_progress_fetch (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(base_url + '/gdq_learninghub_progress/' + payload.course_id)
          .then((resp) => {
            this.commit('learninghub_progress_set', resp.data.result)
            this.commit('learninghub_enrolment_set', resp.data.result.enrolment)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      }).finally(() => {
        this.commit('learninghub_progress_loaded_set', true)
      })
    },
    learninghub_step_toggle (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            base_url + '/gdq_learninghub_progress',
            JSON.stringify(payload),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            this.commit('learninghub_steps_done_set', resp.data.result.steps_done)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    learninghub_substep_toggle (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            base_url + '/gdq_learninghub_progress',
            JSON.stringify(payload),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            this.commit('learninghub_substeps_done_set', resp.data.result.substeps_done)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    learninghub_account_save (_, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            base_url + '/gdq_learninghub_account_save',
            JSON.stringify(payload),
            {
              headers: {
                Accept: 'application/json',
                'Content-type': 'application/json'
              }
            }
          )
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    event_booking_create (_, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url: base_url + '/gdq_event_booking_create',
          data: payload,
          method: 'POST',
          headers: { Authorization: 'Bearer:' + (this.state.token.length > 0 ? this.state.token : api_token) }
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    user: (state) => state.user,
    profile: (state) => state.profile,
    user_id: (state) => state.user_id,
    token: (state) => state.token,
    currentgroup_id: (state) => state.currentgroup_id,
    currentgroup: (state) => state.currentgroup
  },
  plugins: [vuexPersist.plugin]
})
// -----------------
// Helper functions
// -----------------
function gdq_getuserid (token) {
  if (token === '') return 0
  const base64Url = token.split('.')[1] // token you get
  if (base64Url === undefined) {
    return 0
  }
  const base64 = base64Url.replace('-', '+').replace('_', '/')
  const decodedData = JSON.parse(atob(base64))
  return decodedData.id
}
